import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=321b0254&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=321b0254&prod&scoped=true&lang=css&"
import style1 from "./setting.vue?vue&type=style&index=1&id=321b0254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b0254",
  null
  
)

export default component.exports